import { Result } from '@standardnotes/domain-core';
export class DeleteContact {
    constructor(mutator, sync, getOwnedVaults, contactBelongsToVault) {
        this.mutator = mutator;
        this.sync = sync;
        this.getOwnedVaults = getOwnedVaults;
        this.contactBelongsToVault = contactBelongsToVault;
    }
    async execute(dto) {
        if (dto.contact.isMe) {
            throw new Error('Cannot delete self');
        }
        const vaults = this.getOwnedVaults.execute();
        if (vaults.isFailed()) {
            return Result.fail('Failed to get owned vaults');
        }
        for (const vault of vaults.getValue()) {
            const contactBelongsToVault = await this.contactBelongsToVault.execute({
                contact: dto.contact,
                vault: vault,
            });
            if (contactBelongsToVault.isFailed()) {
                return Result.fail('Failed to check contact membership');
            }
            if (contactBelongsToVault.getValue()) {
                return Result.fail('Cannot delete contact that belongs to an owned vault');
            }
        }
        await this.mutator.setItemToBeDeleted(dto.contact);
        await this.sync.sync();
        return Result.ok();
    }
}
